import React, { useRef } from 'react';
import PageHeader from 'components/common/PageHeader';
import { Card, Col, Nav, Row } from 'react-bootstrap';
import Account from './Account';
import Subscription from './Subscription';
import Termination from './Termination';
import Rules from './Rules';

import Instructions from './Instructions';
import useScrollSpy from 'react-use-scrollspy';

const Privacy2Policy = () => {
 const sectionRefs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];

 const activeSection = useScrollSpy({
  sectionElementRefs: sectionRefs,
  offsetPx: -150
 });

 return (
  <>
   <PageHeader
    title="Política de privacidad de Inmovilii"
    description="Bienvenido a Inmovilii, nuestro servicio administrativo de bienes raíces. Nos comprometemos a proteger su privacidad y a garantizar la seguridad de su información personal. Esta Política de privacidad explica cómo recopilamos, usamos y compartimos su información"
    className="mb-3"
   />
   <Row className="g-0">
    <Col lg={8} className="pe-lg-2">
     <Account ref={sectionRefs[0]} />
     <Subscription ref={sectionRefs[1]} />
     <Termination ref={sectionRefs[2]} />
     <Rules ref={sectionRefs[3]} />
     <Instructions ref={sectionRefs[4]} />
     {/* <Rights ref={sectionRefs[5]} /> */}
    </Col>
    <Col lg={4} className="ps-lg-2">
     <div className="sticky-sidebar">
      <Card className="sticky-top">
       <Card.Header className="border-bottom">
        <h6 className="mb-0 fs-0">Resumen</h6>
       </Card.Header>
       <Card.Body>
        <div id="terms-sidebar" className="terms-sidebar nav flex-column fs--1">
         <Nav.Item>
          <Nav.Link href="#account" className="nav-link px-0 py-1" active={activeSection === 0}>
           Cuenta
          </Nav.Link>
         </Nav.Item>
         <Nav.Item>
          <Nav.Link href="#subscriptions" className="nav-link px-0 py-1" active={activeSection === 1}>
           Suscripciones
          </Nav.Link>
         </Nav.Item>
         <Nav.Item>
          <Nav.Link href="#termination" className="nav-link px-0 py-1" active={activeSection === 2}>
           Terminacion
          </Nav.Link>
         </Nav.Item>
         <Nav.Item>
          <Nav.Link href="#rules" className="nav-link px-0 py-1" active={activeSection === 3}>
           Reglas y Abusos
          </Nav.Link>
         </Nav.Item>
         <Nav.Item>
          <Nav.Link href="#instructions" className="nav-link px-0 py-1" active={activeSection === 4}>
           Agregados
          </Nav.Link>
         </Nav.Item>
        </div>
       </Card.Body>
      </Card>
     </div>
    </Col>
   </Row>
  </>
 );
};

export default Privacy2Policy;
